import styled from "styled-components"

export const SpriteImg = styled.img`
  background-color: whitesmoke;
  border-radius: 0.5rem;
  width: 41.4rem;
  height: 41.4rem;
`

export const NameSpriteDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  justify-content: center;
  gap: 0.625rem;
`

export const IdSpan = styled.span`
  font-size: 120%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 200%;
`
export const NameSpan = styled.span`
  font-size: 120%;
  text-align: center;
`
